
<div>
<app-modal-header [title]="title" (closeModal)="closeModal()"></app-modal-header>

  <mat-dialog-content [formGroup]="designationForm">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field
          appearance="outline"
          class="material-form w-full rounded-3xl"
        >
          <mat-label>Designation Short Form</mat-label>
          <input
            formControlName="designationShortForm"
            matInput
            placeholder="Designation Short Form"
            class=""
          />
          <mat-error>
            <span
              *ngIf="
                !designationForm.get('designationShortForm').valid &&
                designationForm.get('designationShortForm').touched
              "
            >
              Field is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="col-md-12">
        <mat-form-field
          appearance="outline"
          class="material-form w-full rounded-3xl"
        >
          <mat-label>Designation Name</mat-label>
          <input
            formControlName="designationName"
            matInput
            placeholder="Designation Name"
            class=""
          />
          <mat-error>
            <span
              *ngIf="
                !designationForm.get('designationName').valid &&
                designationForm.get('designationName').touched
              "
            >
              Field is required
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="d-flex justify-end mt-2">
          <button
          [disabled]="!designationForm.valid"
          class="custom-button submit-btn" color="primary" mat-raised-button
          (click)="submitForm(designationForm.value)"
          type="submit">
            Submit
          </button>

        </div>
      </div>
    </div>
  </mat-dialog-content>
</div>

